// document.addEventListener('DOMContentLoaded', function () {
//     const btnDescp = document.querySelector('#descriptionOpen');
//     const descripElem = document.querySelector('.product_description');

//     btnDescp.addEventListener('click', () => {
//       const isActive = btnDescp.classList.contains('active');

//       if (!isActive) {
//         btnDescp.classList.add('active');
//         descripElem.classList.add('active');
//       } else {
//         btnDescp.classList.remove('active');
//         descripElem.classList.remove('active');
//       }
//     });
//   });


/**
 * Custom Variant Dropdown - Dawn Theme
 * This file handles the custom variant dropdown functionality
 * Place this file in your theme's assets folder as 'custom-variant-dropdown.js'
 */

class CustomVariantDropdown {
  constructor(element) {
    if (!element) return;
    
    this.container = element;
    this.selectedElement = this.container.querySelector('.custom-select__selected');
    this.optionsContainer = this.container.querySelector('.custom-select__options');
    this.hiddenSelect = this.container.querySelector('.custom-select__hidden-select');
    this.selectedTextElement = this.selectedElement.querySelector('.custom-select__selected-text');
    this.formId = this.container.dataset.form;
    this.optionName = this.container.dataset.optionName;
    
    this.container.dataset.dropdownInitialized='true';//27feb

    this.init();
  }
  
  init() {
    // Toggle dropdown on click
    this.selectedElement.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleOptions();
    });
    
    // Setup option click handlers
    const options = this.container.querySelectorAll('.custom-select__option');
    options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.selectOption(option);
      });
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', (event) => {
      if (!this.container.contains(event.target)) {
        this.closeOptions();
      }
    });
    
    // Handle keyboard navigation
    this.container.addEventListener('keydown', (event) => this.handleKeydown(event));
    
    // Add a11y attributes
    this.setupAccessibility();
  }
  
  toggleOptions() {
    if (this.container.classList.contains('is-open')) {
      this.closeOptions();
    } else {
      this.openOptions();
    }
  }
  
  openOptions() {
    this.container.classList.add('is-open');
    this.optionsContainer.setAttribute('aria-hidden', 'false');
    this.selectedElement.setAttribute('aria-expanded', 'true');
  }
  
  closeOptions() {
    this.container.classList.remove('is-open');
    this.optionsContainer.setAttribute('aria-hidden', 'true');
    this.selectedElement.setAttribute('aria-expanded', 'false');
  }
  
  selectOption(option) {
    // Check if disabled
    if (option.classList.contains('is-disabled')) return;
    
    const value = option.dataset.value;
    const productUrl = option.dataset.productUrl;
    const optionValueId = option.dataset.optionValueId;
    
    // Update selected text
    this.selectedTextElement.textContent = option.textContent.trim();
    
    // Update hidden select value
    this.updateHiddenSelect(value);
    
    // Mark selected option
    const allOptions = this.optionsContainer.querySelectorAll('.custom-select__option');
    allOptions.forEach(opt => {
      opt.classList.remove('is-selected');
      opt.setAttribute('aria-selected', 'false');
    });
    
    option.classList.add('is-selected');
    option.setAttribute('aria-selected', 'true');
    
    // Close dropdown
    this.closeOptions();
    
    // Trigger variant change events for Dawn theme
    this.triggerVariantChange(value, productUrl, optionValueId);
  }
  
  updateHiddenSelect(value) {
    if (!this.hiddenSelect) return;
    
    const options = this.hiddenSelect.querySelectorAll('option');
    options.forEach(option => {
      option.selected = option.value === value;
    });
    
    // Dispatch change event to the hidden select
    const event = new Event('change', { bubbles: true });
    this.hiddenSelect.dispatchEvent(event);
  }
  
  triggerVariantChange(value, productUrl, optionValueId) {
    // Find the form and trigger Dawn's variant change handler
    const form = document.getElementById(this.formId);
    if (!form) return;
    
    // Find the correct option element that needs to be updated
    const optionInput = form.querySelector(`[name="options[${this.optionName}]"]`);
    if (optionInput) {
      optionInput.value = value;
      
      // Dawn theme observes all inputs with variant-selects class
      const variantSelects = form.querySelector('variant-selects') || form.querySelector('variant-radios');
      if (variantSelects) {
        // Trigger the Dawn theme's variant change logic
        const changeEvent = new Event('change', { bubbles: true });
        optionInput.dispatchEvent(changeEvent);
      }
    }
  }
  
  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.closeOptions();
      this.selectedElement.focus();
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (!this.container.classList.contains('is-open')) {
        this.openOptions();
      }
      this.focusNextOption();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (!this.container.classList.contains('is-open')) {
        this.openOptions();
      }
      this.focusPreviousOption();
    } else if (event.key === 'Enter' || event.key === ' ') {
      if (document.activeElement === this.selectedElement) {
        event.preventDefault();
        this.toggleOptions();
      } else if (document.activeElement.classList.contains('custom-select__option')) {
        event.preventDefault();
        this.selectOption(document.activeElement);
      }
    }
  }
  
  focusNextOption() {
    const options = [...this.optionsContainer.querySelectorAll('.custom-select__option:not(.is-disabled)')];
    const currentIndex = options.findIndex(opt => opt === document.activeElement);
    
    if (currentIndex === -1) {
      options[0]?.focus();
    } else if (currentIndex < options.length - 1) {
      options[currentIndex + 1].focus();
    }
  }
  
  focusPreviousOption() {
    const options = [...this.optionsContainer.querySelectorAll('.custom-select__option:not(.is-disabled)')];
    const currentIndex = options.findIndex(opt => opt === document.activeElement);
    
    if (currentIndex > 0) {
      options[currentIndex - 1].focus();
    }
  }
  
  setupAccessibility() {
    const selectId = this.container.id;
    const optionsId = `${selectId}-options`;
    
    this.container.setAttribute('role', 'combobox');
    this.container.setAttribute('aria-haspopup', 'listbox');
    this.container.setAttribute('aria-owns', optionsId);
    
    this.selectedElement.setAttribute('aria-expanded', 'false');
    this.selectedElement.setAttribute('tabindex', '0');
    
    this.optionsContainer.id = optionsId;
    this.optionsContainer.setAttribute('role', 'listbox');
    this.optionsContainer.setAttribute('aria-hidden', 'true');
  }
}

// Initialize all custom dropdowns when DOM is loaded
// document.addEventListener('DOMContentLoaded', () => {
//   initCustomDropdowns();
// });

// // Re-initialize on section:load events (for theme editor)
// document.addEventListener('shopify:section:load', (event) => {
//   initCustomDropdowns();
// });

// function initCustomDropdowns() {
//   const customSelects = document.querySelectorAll('.custom-select');
//   customSelects.forEach(select => new CustomVariantDropdown(select));
// }
function initCustomDropdowns() {

  // Only init dropdowns that haven't been initialized yet
  const customSelects = document.querySelectorAll('.custom-select:not([data-dropdown-initialized])');
  customSelects.forEach(select => new CustomVariantDropdown(select));
}
/**
 * Watch for Dawn theme re-rendering the variant selector.
 * Dawn replaces the innerHTML of `variant-selects` / `variant-radios` after
 * a selection, which destroys existing instances. We observe the product
 * section for added nodes that contain `.custom-select` elements and
 * re-initialize them.
 */
function observeVariantSectionMutations() {
  // Scope the observer to the product section so it's lightweight
  const productSection = document.querySelector(
    '.product__info-wrapper, [class*="product-"], .shopify-section--main-product'
  ) || document.body;
  const observer = new MutationObserver((mutations) => {
    let needsReinit = false;
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        // Re-init if a .custom-select itself was added, or if it contains one
        if (
          node.classList?.contains('custom-select') ||
          node.querySelector?.('.custom-select')
        ) {
          needsReinit = true;
          break;
        }
      }
      if (needsReinit) break;
    }
    if (needsReinit) {
      initCustomDropdowns();
    }
  });
  observer.observe(productSection, { childList: true, subtree: true });
}
// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  initCustomDropdowns();
  observeVariantSectionMutations();
});
// Re-initialize on Shopify theme editor section reloads
document.addEventListener('shopify:section:load', () => {
  initCustomDropdowns();
  observeVariantSectionMutations();
});